import React from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '../../types/store.type';
import _ from 'lodash';
import { ReservationUtils } from '../../utils';
import { SideBar } from '../SideBar/SideBar';
import { PalTripSideBar } from '../PalTripSideBar/PalTripSideBar';

/**
 * Renders SideBar or PalTripSideBar depending of the trip information without forcing useTripStoreUpdater.
 * Renders nothing while the trip is loading.
 */
export const AllTripSideBar = () => {
    const trip = useSelector((store: StoreState) => store.trip);
    if (trip.isLoading || !trip.reservation) {
        return null;
    }
    if (ReservationUtils.isPalManaged(trip.reservation)) {
        return <PalTripSideBar />;
    }
    return <SideBar />;
};
